import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import { configUrl } from "../constants/urls";
import useScript from "../hooks/useScript";
const defaultEnv = {
  REACT_PUBLIC_HOST: "",
  REACT_PUBLIC_CONSENT_CLIENT_ID: "",
  REACT_PUBLIC_ADOBE_ANALYTICS_SCRIPT_SRC: "",
  MYBAM_URL: "",
  REACT_APP_LAUNCHDARKLY_CLIENT_ID: "",
};

export const EnvironmentContext = createContext({
  environmentVars: defaultEnv,
});

export const EnvironmentContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [environmentVars, setEnvironment] = useState(defaultEnv);
  useEffect(() => {
    axios
      .get(configUrl)
      .then(res => {
        setEnvironment(res.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error, "error fetch");
      });
  }, []);
  useScript(environmentVars?.REACT_PUBLIC_ADOBE_ANALYTICS_SCRIPT_SRC);

  if (isLoading) return null;

  return (
    <EnvironmentContext.Provider
      value={{
        environmentVars,
      }}
    >
      {children}
    </EnvironmentContext.Provider>
  );
};
